import { HebeClient } from '@/api/client/hebeClient';
import { MateBackendClient } from '@/api/client/mateBackendClient';
import { TransformersClient } from '@/api/client/TransformersClient';

export const hebeClient = new HebeClient();
export const mateBackendClient = new MateBackendClient();
export const transformersClient = new TransformersClient();
